export type LoggedInTooltipProps = {
    notText: string
    firstName: string
}

export const usernameTestid = "header-my-account-container-tooltip-username"
